export default __webpack_public_path__ + "static/media/analog_clock.374b932d.png";